<template>
  <tbody>
    <tr class="tr-row" :class="{expanded, paid: item.status === 'paid'}" @click="toggle">
      <td><fa-icon class="tr-chevron" :icon="['fal', 'chevron-right']"/></td>
      <td class="tr-name">
        Lote {{ item.batch && item.batch.number ? item.batch.number : '—' }}
        <span class="tr-sub">
          <template v-if="guideType">{{ guideType }} · </template>
          <span class="tr-batch-status" :class="`tr-batch-status-${batchStatus}`"
                v-if="batchStatus">{{ batchStatusLabel }}</span>
          <template v-if="item.count">
            · {{ item.count }} {{ item.count === 1 ? 'item' : 'itens' }}
          </template>
        </span>
      </td>
      <td class="hide-sm">{{ insuranceName || '—' }}</td>
      <td class="hide-sm tr-num" :class="{'text-error': overdue}">{{ item.dueDate | date }}</td>
      <td class="text-right tr-num">{{ item.gross | currency }}</td>
      <td class="text-right tr-num">
        <template v-if="hasAdjustments">
          <span class="text-error" v-if="item.glossed > 0">
            {{ signedCurrency(-item.glossed) }}
          </span>
          <span class="text-green" v-if="item.recovered > 0">
            <template v-if="item.glossed > 0"> </template>{{ signedCurrency(item.recovered) }}
          </span>
          <span :class="item.adjustments < 0 ? 'text-error' : 'text-green'" v-if="item.adjustments">
            <template v-if="item.glossed > 0 || item.recovered > 0"> </template>
            {{ signedCurrency(item.adjustments) }}
          </span>
          <span class="tr-sub">{{ adjustmentsNote }}</span>
        </template>
        <span class="text-muted" v-else>—</span>
      </td>
      <td class="text-right tr-num text-bold">{{ item.total | currency }}</td>
      <td>
        <status-pill :status="item.status"/>
        <span class="tr-sub" v-if="item.status === 'paid' && item.paidAt">
          {{ item.paidAt | date }}
        </span>
        <span class="tr-sub" v-else-if="item.document">{{ item.document }}</span>
      </td>
      <td class="text-right text-nowrap" @click.stop>
        <button class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left"
                :data-tooltip="payTooltip" :disabled="!canPay || item.status === 'paid'"
                @click="$emit('pay', item)">
          <fa-icon :icon="['fal', 'hand-holding-usd']"/>
        </button>
        <button class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left"
                data-tooltip="Recibo do repasse" :disabled="!canPrint"
                @click="$emit('print', item)">
          <fa-icon :icon="['fal', 'print']"/>
        </button>
        <button class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left"
                data-tooltip="Ver lote" :disabled="!item.batch || !item.batch.id"
                @click="$emit('open-batch', item)">
          <fa-icon :icon="['fal', 'layer-group']"/>
        </button>
      </td>
    </tr>
    <bundle-items v-if="expanded" :bundle-id="String(item.bundleId)" :colspan="9"
                  title="Itens do profissional neste lote"/>
  </tbody>
</template>

<script>
import moment from 'moment';
import StatusPill from './StatusPill.vue';
import BundleItems from './BundleItems.vue';
import { batchStatuses, guideTypes, signedCurrency } from '../helpers';

export default {
  components: {
    StatusPill,
    BundleItems,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    canPay: {
      type: Boolean,
      default: false,
    },
    canPrint: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    guideType() {
      return this.item.batch ? guideTypes[this.item.batch.guideType] || null : null;
    },
    batchStatus() {
      return this.item.batch ? this.item.batch.status : null;
    },
    batchStatusLabel() {
      return batchStatuses[this.batchStatus] || this.batchStatus;
    },
    insuranceName() {
      return this.item.insurance ? this.item.insurance.customName || this.item.insurance.name : '';
    },
    overdue() {
      return this.item.status !== 'paid'
        && this.item.dueDate
        && moment(this.item.dueDate).isBefore(moment(), 'day');
    },
    hasAdjustments() {
      return this.item.glossed > 0 || this.item.recovered > 0 || !!this.item.adjustments;
    },
    adjustmentsNote() {
      const parts = [];
      if (this.item.glossed > 0) parts.push('glosa');
      if (this.item.recovered > 0) parts.push('recuperado');
      if (this.item.adjustments) parts.push('ajustes anteriores');
      return parts.join(' · ');
    },
    payTooltip() {
      if (this.item.status === 'paid') {
        return this.item.paidAt ? `Pago em ${moment(this.item.paidAt).format('L')}` : 'Pago';
      }
      return this.canPay ? 'Pagar' : 'Sem permissão para pagar';
    },
  },
  methods: {
    signedCurrency,
    toggle() {
      this.expanded = !this.expanded;
    },
  },
};
</script>
